/* ============================================================================
   BT-SERIE — Verhalten der Baureihen-Sections
   ============================================================================
   Herausgeloest am 19.08.2026 (P8) aus bt-serie-groessen, -details und
   -ausstattung. Verschoben wurde nur, was KEIN Liquid enthielt; alles mit
   Section-Einstellungen darin ist bewusst inline geblieben, das laesst sich
   nicht in eine statische Datei ziehen.

   Jeder Abschnitt liegt in seiner eigenen Funktion, damit sich die frueher
   getrennten Skripte keine Variablen teilen. Geladen wird mit defer, das
   DOM steht also.
   ============================================================================ */
/* ---- bt-serie-groessen ---- */
(function(){
(function(){
    var root = document.getElementById('bt-sg');
    if(!root || root.dataset.sgInit === '1') return;
    root.dataset.sgInit = '1';
    var M = [], CFG = {};
    try { M = JSON.parse(root.querySelector('[data-sg-data]').textContent); } catch(e){ return; }
    try { CFG = JSON.parse(root.querySelector('[data-sg-config]').textContent); } catch(e){}
    if(!M.length) return;
    /* Mehrsprachigkeit (30.09.2026): Zahlenformat folgt der Sprache, die
       Waehrung dem Markt (CFG.cur aus cart.currency). Deutsch mit EUR bleibt
       exakt wie bisher. */
    var lang = document.documentElement.lang || 'de';
    var cur = CFG.cur || 'EUR';
    var eur = function(n){
      if(cur === 'EUR' && /^de/i.test(lang)) return n.toLocaleString(lang, { minimumFractionDigits: 0 }) + ' €';
      try { return n.toLocaleString(lang, { style: 'currency', currency: cur, minimumFractionDigits: 0 }); }
      catch(e){ return n.toLocaleString(lang, { minimumFractionDigits: 0 }) + ' ' + cur; }
    };
    var dez = /^en/i.test(lang) ? '.' : ',';
    var cm = function(n){ return String(n).replace('.', dez); };
    var silh = root.querySelector('[data-sg-silh]');
    /* Massstab am GROESSTEN Element (Modell oder Person), damit das Chart
       immer exakt 200px hoch ist und kein Leerraum entsteht. */
    var figCm = (CFG.fig && CFG.fig.url && CFG.fig.cm > 0) ? CFG.fig.cm : 0;
    var maxCm = Math.max(CFG.maxh || 0, figCm);
    var k = maxCm > 0 ? 200 / maxCm : 0;

    /* Tabellen-Aufbau: Label-Spalte links (Hoehe/Breite/Tiefe ausgeschrieben),
       je Modell eine Spalte mit festen Zeilenhoehen, Personen-Figur als
       Vergleich rechts. Boxen wachsen animiert hoch, wenn das Chart in den
       Viewport kommt (Chris 18.08., besonders mobil). */
    var figH = figCm > 0 ? Math.round(figCm * k) : 0;
    var chartH = 200;
    /* Referenzlinien alle 50 cm quer durchs Chart, damit sich auch das
       rechte Modell mit der Person links vergleichen laesst (Chris 18.08.).
       Als echte Elemente statt Background-Gradient, das rendert zuverlaessig
       und laeuft ueber die volle Scroll-Breite. */
    function glinien(){
      if(!silh || k <= 0) return;
      silh.querySelectorAll('.bt-sg__gline').forEach(function(el){ el.remove(); });
      var step = Math.round(50 * k);
      if(step < 9) return;
      var breite = Math.max(silh.scrollWidth, silh.clientWidth);
      for(var y = step; y < chartH - 4; y += step){
        var ln = document.createElement('i');
        ln.className = 'bt-sg__gline';
        ln.style.top = (chartH - y) + 'px';
        ln.style.width = breite + 'px';
        silh.appendChild(ln);
      }
    }
    var hasVol = false, hasCap = false;
    M.forEach(function(m){ if(m.vol > 0) hasVol = true; if(m.cap) hasCap = true; });
    if(!CFG.metrikLabel || CFG.metrik === 'liter') hasCap = false;
    function zelle(cls, txt){ return '<span class="' + cls + '">' + (txt || '') + '</span>'; }
    function extraZellen(vol, cap){
      return (hasVol ? zelle('bt-sg__sh', vol) : '') + (hasCap ? zelle('bt-sg__sh', cap) : '');
    }
    if(silh){
      var lab = document.createElement('div');
      lab.className = 'bt-sg__si bt-sg__silabels';
      lab.innerHTML = '<div class="bt-sg__sboxw" style="height:' + chartH + 'px"></div>'
        + zelle('bt-sg__sname', '')
        + zelle('bt-sg__sh', btT('bt_serie.height', 'Höhe')) + zelle('bt-sg__sh', btT('bt_serie.width', 'Breite')) + zelle('bt-sg__sh', btT('bt_serie.depth', 'Tiefe'))
        + extraZellen(btT('bt_serie.volume', 'Volumen'), CFG.metrikLabel)
        + zelle('bt-sg__srow--star', '');
      silh.appendChild(lab);
    }
    /* Personen-Figur GANZ LINKS neben den Labels, damit sie auch bei vielen
       Modellen (horizontales Scrollen) immer sichtbar bleibt. */
    if(silh && figH > 0){
      var fig = document.createElement('div');
      fig.className = 'bt-sg__si bt-sg__sifig';
      fig.innerHTML = '<div class="bt-sg__sboxw" style="height:' + chartH + 'px"><img class="bt-sg__figimg" src="' + CFG.fig.url + '" alt="' + btT('bt_serie.person_alt', 'Größenvergleich: Person mit {cm} cm', {cm: cm(CFG.fig.cm)}) + '" style="height:' + figH + 'px" loading="lazy"></div>'
        + zelle('bt-sg__sname', btT('bt_serie.person', 'Person'))
        + zelle('bt-sg__sh', cm(CFG.fig.cm) + ' cm')
        + zelle('bt-sg__sh', '') + zelle('bt-sg__sh', '')
        + extraZellen('', '')
        + zelle('bt-sg__srow--star', '');
      silh.appendChild(fig);
    }
    M.forEach(function(m, i){
      if(silh && m.h > 0){
        var s = document.createElement('button');
        s.type = 'button'; s.className = 'bt-sg__si'; s.dataset.i = i;
        var bw = Math.max(10, Math.round((m.b || 50) * k));
        /* Zweifluegelige Modelle: Metafeld custom.zweifluegelig als Override
           (true erzwingt Doppeltuer, false erzwingt eine Tuer), sonst greift
           die Breiten-Automatik ab 110 cm. Die Schwelle ist an echten
           Modellen abgeglichen (19.08.): EINE Tuer bei Ajax 190 (90 cm),
           Hathor 18/18L (94 cm) und Apate 200 (100 cm), ZWEI Tueren bei
           Hathor 27 (119 cm), Apate 200B (120 cm), Taranis 130B (125 cm)
           und Apis 190B (129 cm). Die Grenze liegt also zwischen 100 und
           120. Darstellung: Mittellinie plus zwei Goldpunkte, je einer
           links und rechts. */
        var zwei = (m.zwei === true || m.zwei === false) ? m.zwei : (m.b >= 110);
        var tsplit = zwei ? '<i class="bt-sg__tsplit"></i><i class="bt-sg__tdot2"></i>' : '';
        s.innerHTML = '<div class="bt-sg__sboxw" style="height:' + chartH + 'px"><div class="bt-sg__sbox' + (zwei ? ' bt-sg__sbox--zwei' : '') + '" style="height:' + Math.max(10, Math.round(m.h * k)) + 'px; width:' + bw + 'px; transition-delay:' + (i * 70) + 'ms">' + tsplit + '</div></div>'
          + zelle('bt-sg__sname', m.name.replace(/^[A-Za-zÄÖÜäöüß]+\s/, ''))
          + zelle('bt-sg__sh', m.h > 0 ? cm(m.h) + ' cm' : '')
          + zelle('bt-sg__sh', m.b > 0 ? cm(m.b) + ' cm' : '')
          + zelle('bt-sg__sh', m.t > 0 ? cm(m.t) + ' cm' : '')
          + extraZellen(m.vol > 0 ? cm(m.vol) + ' l' : '', m.cap ? String(m.cap) : '')
          + '<span class="bt-sg__srow--star">' + (m.best ? '<span class="bt-sg__star">' + (CFG.bestLabel || btT('bt_serie.most_popular', 'Beliebteste')) + '</span>' : '') + '</span>';
        s.addEventListener('click', function(){ waehle(i, true); });
        silh.appendChild(s);
      }
    });
    glinien();
    window.addEventListener('resize', glinien);
    if(silh){
      var reduziert = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if(reduziert || !('IntersectionObserver' in window)){ silh.classList.add('in'); }
      else {
        var sio = new IntersectionObserver(function(en){
          en.forEach(function(x){ if(x.isIntersecting){ silh.classList.add('in'); sio.disconnect(); } });
        }, { threshold: .25 });
        sio.observe(silh);
      }
    }

    function waehle(i, scroll){
      root.querySelectorAll('.bt-sg__si').forEach(function(el){ el.classList.toggle('is-active', +el.dataset.i === i); });
      var m = M[i];
      var st = root.querySelector('[data-sg-sticky]');
      root.querySelector('[data-sg-stname]').textContent = m.name;
      root.querySelector('[data-sg-stspec]').textContent = (m.cap && CFG.metrik ? m.cap + ' ' + CFG.metrikLabel + ' · ' : '') + (m.h > 0 ? cm(m.h) + ' × ' + cm(m.b) + ' × ' + cm(m.t) + ' cm · ' : '') + btT('bt_serie.from_price', 'ab {price}', {price: eur(m.preis)});
      var link = root.querySelector('[data-sg-stlink]');
      link.href = m.url; link.textContent = btT('bt_serie.to_model', 'Zum {name}', {name: m.name});
      st.classList.add('show');
      void scroll;
    }

    var fh = root.querySelector('[data-sg-fh]'), fb = root.querySelector('[data-sg-fb]'), ft = root.querySelector('[data-sg-ft]');
    function fitCheck(){
      var vh = fh && +fh.value || 0, vb = fb && +fb.value || 0, vt = ft && +ft.value || 0;
      var aktiv = vh || vb || vt, passend = 0;
      var tzaG = parseFloat(CFG.tza) || 0;
      M.forEach(function(m, i){
        var tza = tzaG;
        var ok = m.h > 0 && (!vh || m.h <= vh) && (!vb || m.b <= vb) && (!vt || m.t + tza <= vt);
        if(m.h <= 0) ok = true;
        if(ok && aktiv) passend++;
        var sEl = root.querySelector('.bt-sg__si[data-i="' + i + '"]');
        if(sEl) sEl.classList.toggle('is-dim', !!aktiv && !ok);
        /* Produktkarten im Standard-Grid ausblenden: die Karte IST der Anker
           (a.cdx-pc-tile aus cdx-product-card), Fallback product-item. */
        document.querySelectorAll('a[data-pc-tile][href*="/products/' + m.handle + '"], a.cdx-pc-tile[href*="/products/' + m.handle + '"], .product-item a[href*="/products/' + m.handle + '"]').forEach(function(a){
          if(root.contains(a)) return;
          var card = a.matches('[data-pc-tile], .cdx-pc-tile') ? a : (a.closest('.product-item') || a);
          card.style.display = (aktiv && !ok) ? 'none' : '';
        });
      });
      var msg = root.querySelector('[data-sg-fitmsg]');
      if(!msg) return;
      if(!aktiv) msg.innerHTML = btT('bt_serie.fit_hint', 'Optional: Messen Sie Ihre Stellfläche, wir markieren die passenden Größen. Bei der Tiefe rechnen wir {cm} cm für Griff und Scharniere bereits mit ein.', {cm: String(parseFloat(CFG.tza) || 0).replace('.', dez)});
      else if(passend === 0){
        var awTreffer = 0;
        if(CFG.aw && CFG.aw.masse){
          CFG.aw.masse.forEach(function(am){
            if(am[0] > 0 && (!vh || am[0] <= vh) && (!vb || am[1] <= vb) && (!vt || am[2] + tzaG <= vt)) awTreffer++;
          });
        }
        if(awTreffer > 0){
          msg.innerHTML = (awTreffer === 1
              ? btT('bt_serie.fit_sister_one', 'In diese Nische passt kein {serie}. Die schmaler gebaute Schwester-Serie passt mit {n} Größe:', {serie: CFG.serie || btT('bt_serie.model', 'Modell'), n: awTreffer})
              : btT('bt_serie.fit_sister_other', 'In diese Nische passt kein {serie}. Die schmaler gebaute Schwester-Serie passt mit {n} Größen:', {serie: CFG.serie || btT('bt_serie.model', 'Modell'), n: awTreffer}))
            + ' <a href="' + CFG.aw.url + '" style="color:#0B1D5E;font-weight:800;">' + btT('bt_serie.to_series', 'Zur {name}', {name: CFG.aw.name}) + ' &rarr;</a>';
        } else {
          msg.innerHTML = btT('bt_serie.fit_none', 'In diese Nische passt kein Modell der Serie. Rufen Sie uns an, wir finden eine Lösung.');
        }
      }
      else msg.innerHTML = btT('bt_serie.fit_count_html', '<b>{n} von {total} Größen passen</b> in Ihre Stellfläche.', {n: passend, total: M.length});
    }
    [fh, fb, ft].forEach(function(el){ if(el) el.addEventListener('input', fitCheck); });

    /* Produkt-Grid nach Groesse sortieren (Chris 18.08.): das Serien-Template
       zeigt die Modelle aufsteigend nach Hoehe, unabhaengig von der
       Collection-Sortierung oder der KI-Sortierung von Boost. Laeuft nur
       beim Laden (mit Retries fuer das asynchrone Boost-Rendering); waehlt
       der Nutzer danach selbst eine Sortierung, greifen wir nicht mehr ein.
       Standard-Collections sind nicht betroffen, das Skript liegt nur im
       Serien-Template. */
    var gridSorted = false;
    function gridReorder(){
      if(gridSorted) return;
      var karten = [];
      M.forEach(function(m){
        var a = document.querySelector('a[data-pc-tile][href*="/products/' + m.handle + '"], a.cdx-pc-tile[href*="/products/' + m.handle + '"], .product-item a[href*="/products/' + m.handle + '"]');
        if(!a || root.contains(a)) return;
        var card = a.matches('[data-pc-tile], .cdx-pc-tile') ? a : (a.closest('.product-item') || a);
        karten.push(card);
      });
      if(karten.length < 2) return;
      var cont = karten[0].parentElement;
      var ok = true;
      karten.forEach(function(c){ if(c.parentElement !== cont) ok = false; });
      if(!ok) return;
      karten.forEach(function(c){ cont.appendChild(c); });
      gridSorted = true;
    }
    gridReorder();
    [400, 1000, 2000, 4000, 8000].forEach(function(t){ setTimeout(gridReorder, t); });
  })();
})();

/* ---- bt-serie-ausstattung ---- */
(function(){
(function(){
    var sec = document.getElementById('bt-serie-ausstattung');
    if(!sec || sec.dataset.axInit === '1') return;
    sec.dataset.axInit = '1';
    var row = sec.querySelector('[data-ax-row]');
    var prev = sec.querySelector('[data-ax-prev]');
    var next = sec.querySelector('[data-ax-next]');
    if(!row) return;
    function upd(){
      if(prev) prev.disabled = row.scrollLeft <= 4;
      if(next) next.disabled = row.scrollLeft + row.clientWidth >= row.scrollWidth - 4;
    }
    if(prev) prev.addEventListener('click', function(){ row.scrollBy({ left: -row.clientWidth * 0.8, behavior: 'smooth' }); });
    if(next) next.addEventListener('click', function(){ row.scrollBy({ left: row.clientWidth * 0.8, behavior: 'smooth' }); });
    row.addEventListener('scroll', upd, { passive: true });
    window.addEventListener('resize', upd);
    upd();
  })();
})();

/* ---- bt-serie-details ---- */
(function(){
(function(){
  var root = document.querySelector('[data-bt-serie-details]');
  if (!root || root.dataset.btInit === '1') return;
  root.dataset.btInit = '1';
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var els = root.querySelectorAll('.bt-rv');
  if (reduced || !('IntersectionObserver' in window)) {
    els.forEach(function(e){ e.classList.add('in'); });
  } else {
    var io = new IntersectionObserver(function(en){
      en.forEach(function(x){ if(x.isIntersecting){ x.target.classList.add('in'); io.unobserve(x.target); } });
    }, { threshold:.15 });
    els.forEach(function(e){ io.observe(e); });
  }
})();
})();
